<script lang="ts">
	import Link from "./Link.svelte";
	import type { Breadcrumb } from "../../../core/schema/Breadcrumb.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import arrowLeft from "../../../core/assets/icons/arrow-left.svg?raw";
	import translations from "./Breadcrumbs.translations.json";
	import Icon from "./Icon.svelte";
	import { getTranslate } from "../utils/getTranslate.js";

	export let pageSlug: string;
	export let breadcrumbs: Breadcrumb[];
	export let showBackLink = true;

	const translate = getTranslate(translations);

	const breadcrumbsBackUrl = breadcrumbs.length > 1 && breadcrumbs[breadcrumbs.length - 2]?.url;
</script>

{#if breadcrumbs.length > 0}
	<nav class="hidden py-4 md:container md:block md:px-16 md:py-8 xl:px-32">
		<div class="flex justify-between gap-6">
			<ul class="font-lexend flex flex-1 items-center gap-2 overflow-x-auto text-base/normal font-light uppercase">
				{#each breadcrumbs as { url, label }, index}
					<li>
						<Link
							class="!text-ltprimary-200 !decoration-ltprimary-200 flex gap-2.5 text-nowrap"
							href={url}
							iconGap="mr-0"
							noUnderline={url !== `/${pageSlug}`}
						>
							<span>
								{nbspify(label)}
							</span>
						</Link>
					</li>
					{#if index < breadcrumbs.length - 1}
						<li class="text-[#CDC7FF]">/</li>
					{/if}
				{/each}
			</ul>
			{#if showBackLink && breadcrumbsBackUrl}
				<Link
					class="!text-ltprimary-200 !decoration-ltprimary-200 hidden gap-2.5 text-nowrap text-xs/loose md:!flex"
					href={breadcrumbsBackUrl}
					iconGap="mr-0"
					noUnderline
				>
					<span class="flex items-center gap-2.5">
						<Icon icon={arrowLeft} class="text-ltprimary-200 w-4" />
						<span>{translate("back")}</span>
					</span>
				</Link>
			{/if}
		</div>
	</nav>
{/if}
